<template>
   <div>
       <header-title :title="title"></header-title>
        <rs-form :model="formData" :show-message="false" label-width="156px" size="small" :rules="rules" ref="formData" class="form-70 commom-form">
            <rs-row>  
                <rs-col :span="12">
                    <rs-form-item label="组织名称" prop="orgName">
                        <rs-input v-model="formData.orgName" :maxlength="20" placeholder="请输入"></rs-input>
                    </rs-form-item>
                </rs-col>
                <rs-col :span="12">
                    <rs-form-item label="上级组织">
                        <org-select :organizationSysCode="formData.parentOrgSysCode" @orgSelectChange="orgSelectChange"></org-select>
                    </rs-form-item>
                </rs-col>
            </rs-row>
            <rs-row> 
                <rs-col :span="12">
                    <rs-form-item label="组织描述">
                        <rs-input v-model="formData.remark" type="textarea" show-word-limit maxlength="200" :rows="5" placeholder="请输入"></rs-input>
                    </rs-form-item>
                </rs-col>
                <rs-col :span="12">
                    <rs-form-item label="选择状态">
                        <rs-select
                            v-model="formData.status"
                            placeholder="选择状态">
                            <rs-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </rs-option>
                        </rs-select>
                    </rs-form-item>
                </rs-col>
            </rs-row>
        </rs-form>
        <div class="edit-form button-box" style="text-align: right">
            <rs-button size="small"  @click="jumpBack(false)">取消</rs-button>
            <rs-button size="small" @click="save" type="primary" :loading="saveLoading">保存</rs-button>
        </div>
    </div>
</template>
<script>
    import Api from '@/api/organizationApi'
    import orgSelect from '@/components/orgSelect'
    import headerTitle from '@/components/header'
    export default {
        components: {
            orgSelect,
            headerTitle
        },
        computed:{
        },
        data() {
            return {
                formData: {
                    status: true
                },
                rules: {
                    orgName: [
                        {required: true, message: '请输入组织名称', trigger: 'change'},
                        { max: 20, message: '最多20个字符', trigger: 'change' }
                    ],
                    status: [{required: true, message: '请选择状态', trigger: 'change'}]
                },
                statusOptions: [
                    {label: '已启用', value: true},
                    {label: '已停用', value: false},
                ],
                treeParams: {
                    clickParent: true,
                    filterable: true,
                    'check-strictly': true,
                    'default-expand-all': true,
                    'expand-on-click-node': false,
                    // 'check-on-click-node': true,
                    'highlight-current': true,
                    // 'show-checkbox': true,
                    data: [],
                    props: {
                        children: 'children',
                        label: 'orgName',
                        disabled: 'disabled',
                        value: 'orgSysCode'
                    }
                },
                userId: '',
                saveLoading: false,
                title: ''
            }
        },
        async created() {
            this.title = '新建组织'
            if(this.$route.query.id) {
                this.title = '编辑组织'
                this.userId = this.$route.query.id
                await this.handleDetail()
            } 
        },
        methods: {
            orgSelectChange(val) {
                this.formData.parentOrgSysCode = val.value || ''
            },
            validate(cb) {
                this.$refs['form'].validate(cb);
            },
            resetFields() {
                this.$refs.form.resetFields();
            },
            // 获取详情
            async handleDetail() {
                let res = await Api.queryOrganizationDetail({id: this.userId})
                this.formData = res.data.data
            },
            // 弹框确认新增
            save() {
                this.$refs['formData'].validate((valid) => {
                    if (valid) {
                        this.saveLoading = true
                        Api.saveOrganization(this.formData).then(res=>{
                            this.saveLoading = false
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.jumpBack()
                        }).catch(err=>{})
                    } 
                });
            },
            jumpBack() {
                // this.$closeTabSwitch()
                this.$router.back()
            },
        }
    }
    
</script>
<style lang="less" scoped>
.demo-ruleForm {
    width: 400px;
}
</style>